import React from "react";
import PropTypes from "prop-types";
import parseISO from "date-fns/parseISO";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import { Ellipsis } from "components/ui/Ellipsis";
import { BaseItemStyles } from "./BaseItemStyles";

export function BDriveItem({ item }) {
  const {
    title,
    link,
    icon_url,
    editor,
    changeState,
    modifiedTime: { dateTime: modifiedTime },
  } = item;

  return (
    <BaseItemStyles>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: `flex`,
          justifyContent: `flex-start`,
          gap: `var(--md)`,
          alignItems: `center`,
        }}
      >
        <img src={icon_url} width="16" height="16" />
        <div style={{ overflowX: `hidden` }}>
          <Ellipsis style={{ fontWeight: `bold` }}>{title}</Ellipsis>
          <Ellipsis
            style={{
              fontSize: `var(--tiny-font-size)`,
              color: `var(--dusty-gray)`,
            }}
          >
            {changeState} by {editor} &bull;{" "}
            {formatDistanceToNow(parseISO(modifiedTime), { addSuffix: true })}
          </Ellipsis>
        </div>
      </a>
    </BaseItemStyles>
  );
}

BDriveItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string,
    icon_url: PropTypes.string,
    editor: PropTypes.string,
    changeState: PropTypes.string,
    modifiedTime: PropTypes.shape({
      epoch: PropTypes.number,
      dateTime: PropTypes.string,
      dateString: PropTypes.string,
    }),
  }),
};
